export default [{ path: 'warning', component: () => import('pages/warning/warning-index') }];
